// extracted by mini-css-extract-plugin
module.exports = {"search-input":"SearchInput_search-input__yKgGd","active":"SearchInput_active__27f_x"};